import React, { createContext, useMemo } from 'react';

import { ApolloClient } from '@apollo/client';
import { useAuth0 } from '@auth0/auth0-react';
import { createAdministratorApiClient, createAuthenticationApiClient } from '@dashboard/utilities/apollo';

// We don't care about the CacheShape, which is what the Generic is setting here
// eslint-disable-next-line @typescript-eslint/no-explicit-any
type TClient = ApolloClient<any>;

type TContext = {
  authenticationClient: TClient;
  administratorClient: TClient;
};

export const AuthenticationClientContext = createContext<TContext | null>(null);

type Props = {
  apiHost: string;
  children: JsxNode;
};
export default function AuthenticationClientManager({ apiHost, children }: Props) {
  const { getAccessTokenSilently } = useAuth0();
  const context = useMemo<TContext>(
    () => ({
      authenticationClient: createAuthenticationApiClient({
        apiHost,
        getAccessTokenSilently,
      }),
      administratorClient: createAdministratorApiClient({
        apiHost,
        getAccessTokenSilently,
      }),
    }),
    [apiHost, getAccessTokenSilently]
  );
  return <AuthenticationClientContext.Provider value={context}>{children}</AuthenticationClientContext.Provider>;
}
